<template>
    <slot
        :sample=" BstkCSVImportData.firstSampleRow"
        :map="BstkCSVImportData.map"
        :fields="BstkCSVImportData.fields"
    >
        <template v-if="BstkCSVImportData.firstSampleRow">
            <table v-bind="$attrs">
                <thead v-if="!noThead">
                    <tr>
                        <th>{{ labels.fieldColumn }}</th>
                        <th>{{ labels.csvColumn }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(field, key) in BstkCSVImportData.fields" :key="key">
                        <td>{{ field.label }}</td>
                        <td>
                            <select
                                v-bind="selectAttributes"
                                :name="`csv_uploader_map_${key}`"
                                v-model="BstkCSVImportData.map[field.key]"
                            >
                                <option v-if="!field.required" :value="null">&nbsp;</option>
                                <option
                                    v-for="(column, key) in BstkCSVImportData.firstSampleRow"
                                    :key="key"
                                    :value="key"
                                >{{ column }}
                                </option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </slot>
</template>

<script>
    import {inject, watch} from 'vue';

    /* eslint-disable */
    export default {
        name: "CsvMap",
        props: {
            noThead: {
                type: Boolean,
                default: false,
            },
            selectAttributes: {
                type: Object,
                default() {
                    return {};
                }
            },
            autoMatch: {
                type: Boolean,
                default: true
            },
            autoMatchIgnoreCase: {
                type: Boolean,
                default: true
            }
        },
        setup(props) {
            const BstkCSVImportData = inject('BstkCSVImportData');
            const buildMappedCsv = inject('buildMappedCsv');
            const labels = BstkCSVImportData.language;

            watch(() => BstkCSVImportData.map, function () {
                if (BstkCSVImportData.allFieldsAreMapped) {
                    buildMappedCsv();
                }
            }, {deep: true});

            if (props.autoMatch) {
                watch(() => BstkCSVImportData.csvSample, function (newVal) {
                    if (newVal) {
                        BstkCSVImportData.fields.forEach(field => {
                            newVal[0].forEach((columnName, index) => {
                                let fieldName = props.autoMatchIgnoreCase ? field.label.toLowerCase().trim() : field.label.trim();
                                let colName = props.autoMatchIgnoreCase ? columnName.toLowerCase().trim() : columnName.trim();
                                if (fieldName === colName) {
                                    BstkCSVImportData.map[field.key] = index;
                                }
                            });
                        });
                    }
                });
            }

            return {
                BstkCSVImportData,
                labels
            }
        },
    };
</script>